import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { SchemaUtil } from '../utils/schema.util';
import { SourcePlainObject } from '../plainObjects/source.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class SourceVisitor extends BaseTransformationVisitor {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitOutputDefinition(outputDefinitionContext: any): void {
        (this.transformation as SourcePlainObject).columns = SchemaUtil.getSchemaFromInputOutputDefinition(outputDefinitionContext);
    }
}
